import { Theme, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  leftSideContainer: {
    marginTop: 120,
    [theme.breakpoints.down('xs')]: {
      marginTop: '14%',
      paddingLeft: '4%',
      paddingRight: '4%',
    },
    [theme.breakpoints.up('sm')]: {
      paddingLeft: '8%',
      paddingRight: '8%',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: 120,
      paddingLeft: '10%',
      paddingRight: '10%',
    },
  },
  leftTitle: {
    color: '#000',
    fontFamily: 'InterSemiBold',
    fontStyle: 'normal',
    fontweight: 'bold',
    fontSize: 36,
    lineHeight: '35px',
    marginBottom: 33,
    textAlign: 'start',
  },
  rightSideContainer: {
    backgroundColor: theme.palette.background.default,
  },
  bottomContainer: {
    padding: 20,
  },
  cardsContainer: {
    marginLeft: -20,
    marginTop: '10%',
  },
  divider: {
    marginTop: 30,
    height: 2,
    width: '40%',
    backgroundColor: theme.palette.primary.main,
    borderRadius: 0,
    marginLeft: '30%',
  },
  carruselTitle: {
    fontFamily: 'Barlow',
    fontWeight: 600,
    fontSize: 24,
    lineHeight: '26px',
    color: theme.palette.primary.light,
    marginTop: 40,
    textAlign: 'center',
  },
  buttonNext: {
    background: 'transparent',
    borderColor: 'transparent',
  },
  buttonNextBox: {
    textAlign: 'end',
  },
  answerLog: {
    width: 170,
    // marginLeft: -30,
    marginBottom: 70,
    [theme.breakpoints.down('xs')]: {
      alignItems: 'center',
    },
  },
}));

export const styles = {
  answerBackgroundImg: {
    maxWidth: '200%',
  },
  buttonNext: {
    height: 20,
  },
  logoAnswerWidth: {
    width: 170,
  },
};
